import { helper } from '@ember/component/helper';
import { isArray as isEmberArray } from '@ember/array';
import { toArray } from './sort-by';

/**
 * Replacement for ember-composable-helpers' flatten that also flattens
 * EmberData PromiseManyArray elements. The upstream helper recurses with
 * asArray(el).reduce(...), and PromiseManyArray (ember-data >= 4) passes its
 * isEmberArray check while having no reduce method, so a template like
 * {{flatten (map-by "someHasMany" rows)}} throws. toArray (shared with our
 * sort-by override) converts PromiseManyArray via .content.
 *
 * Semantics mirror upstream otherwise: non-array input is returned as-is,
 * nested arrays flatten deeply.
 */
function isArrayLike(value) {
  return (
    Array.isArray(value) ||
    isEmberArray(value) ||
    (value != null &&
      typeof value === 'object' &&
      typeof value.then === 'function' &&
      'content' in value)
  );
}

export function flatten(value) {
  if (!isArrayLike(value)) {
    return value;
  }

  return toArray(value).reduce(
    (flattened, el) => flattened.concat(flatten(el)),
    []
  );
}

export default helper(([value]) => flatten(value));
